import Breadcrumb from "../components/Breadcrumb";

const NewsletterSubscriptionSuccess = () => {
  const textStyle = {
    fontFamily: "Lato, Arial, sans-serif",
    fontSize: "18px",
    lineHeight: "1.6",
    margin: "10px 0",
    fontWeight: "300",
    color: "#333",
  };

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <div className="relative w-full h-[45vw] md:h-[25vw] sm:h-[30vw] overflow-hidden">
        <img
          src="/images/La_Fenice_auditorium.jpg"
          alt="Composers Hero"
          className="w-full h-full object-cover"
        />
      </div>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "NewsLetter", href: "/newsletter" },
          { label: "Thank you", href: "/thank-you-newsletter" },
        ]}
      />
      <main
        className="max-w-[1280px] mx-auto py-12 px-6 md:px-12"
        aria-label="Site Notice"
      >
        <div className="flex flex-col justify-center">
          <div className="text-left">
            <h1 className="text-4xl md:text-3xl text-opera-red mb-4">Thank you for subscribing!</h1>
            <p
              className="text-base leading-relaxed mb-4 text-gray-800 font-light"
              style={textStyle}
            >
              We’re delighted to welcome you to our community of opera lovers.
            </p>
            <p
              className="text-base leading-relaxed mb-4 text-gray-800 font-light"
              style={textStyle}
            > From now on, you'll receive exclusive news, travel ideas, and highlights from the world of opera.
              In the meantime, feel free to explore our website for the latest performances, travel offers, and seasonal inspirations.</p>
            <p
              className="text-base leading-relaxed mb-4 text-gray-800 font-light"
              style={textStyle}
            > Do you have any questions, booking requests, or would you like to order a gift voucher?
              We’re happy to assist you – don’t hesitate to get in touch!</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NewsletterSubscriptionSuccess;
